import { mutator } from 'satcheljs';
import getStore from '../store/store';
import { setAccountScope } from '../actions/searchStoreActions';
import { getOWAConnectedAccounts } from 'owa-accounts-store';
import { getDefaultLogonEmailAddress } from 'owa-session-store';

export let setAccountScopeMutator = mutator(setAccountScope, actionMessage => {
    let store = getStore();
    const { initializeAccountScope, account } = actionMessage;

    if (initializeAccountScope) {
        // We only want to initialize the account scope if there are any connected accounts
        const connectedAccounts = getOWAConnectedAccounts();

        if (connectedAccounts?.length > 0) {
            // TODO: VSO# 59108 Get the selected calendars list to determine the initial account so that we can set the
            // connected account as the default scope if there are no primary account calendars selected
            const initializeWithConnectedAccount = false;

            store.accountSmtpAddress = initializeWithConnectedAccount
                ? connectedAccounts[0].userIdentity
                : getDefaultLogonEmailAddress();
        }
    } else {
        store.accountSmtpAddress = account;
    }
});
